import { render } from "./B2bTimeline.vue?vue&type=template&id=f5fdd138&scoped=true&lang=pug"
import script from "./B2bTimeline.vue?vue&type=script&lang=js"
export * from "./B2bTimeline.vue?vue&type=script&lang=js"

import "./B2bTimeline.vue?vue&type=style&index=0&id=f5fdd138&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5fdd138"]])

export default __exports__